var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCourseHostingVd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 40,
    viewBox: "0 0 43 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14115",
    "data-name": "Group 14115",
    transform: "translate(-812 -3869)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14106",
    "data-name": "Group 14106",
    transform: "translate(-465 -1552)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_375",
    "data-name": "Rectangle 375",
    width: 43,
    height: 40,
    rx: 12,
    transform: "translate(1277 5421)",
    fill: "#3488eb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "virtual-classroom-svgrepo-com",
    d: "M22,2a2,2,0,0,1,2,2V17a2,2,0,0,1-2,2H14.8l3.06,2.186A1,1,0,0,1,17.28,23H6.72a1,1,0,0,1-.58-1.814L9.2,19H2a2,2,0,0,1-2-2V4A2,2,0,0,1,2,2Zm0,2H2V17H6V16a3,3,0,0,1,3-3h6a3,3,0,0,1,3,3v1h4ZM15,15H9a1,1,0,0,0-.993.883L8,16v1h8V16a1,1,0,0,0-.883-.993ZM12,5A4,4,0,1,1,8,9,4,4,0,0,1,12,5Zm0,2a2,2,0,1,0,2,2A2,2,0,0,0,12,7Z",
    transform: "translate(823 3878)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseHostingVd);
export default __webpack_public_path__ + "static/media/course-hosting-vd.1d4db3737ba91d620c921748752cf937.svg";
export { ForwardRef as ReactComponent };